import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginlink } from 'api/login'
import { SplashScreen } from 'components/loading-screen';

/**
 * RedirectPage handles the login link sent to users via email.
 * It makes an API call to verify the link and logs the user in
 * if successful, or redirects to the homepage if not.
 * @returns {JSX.Element} A loading screen while the link is being processed.
 */
const RedirectPage = () => {
    const navigate = useNavigate();
    useEffect(() => {
        /**
         * fetchData makes an API call to verify the login link and logs the user in
         * if successful, or redirects to the homepage if not.
         * @returns {Promise<void>}
         */
        const fetchData = async () => {
            try {
                const token = window.location.pathname.split('/').pop();

                if (token) {
                    const response = await loginlink({ token });
                    if (response?.success && response.data) {
                        navigate('/reset-password', { state: { user: response.data } });
                    } else {
                        navigate('/');
                    }
                } else {
                    navigate('/');
                }
            } catch (error) {
                console.error('Error processing login link:', error);
                navigate('/');
            }
        };

        fetchData();
    }, []);


    return (<SplashScreen />);
};

export default RedirectPage;
